import { FormActions } from "../../components/common/FormActions";
import { API_PAYMENT_TYPES } from "../../utils/apis";
import {
  beautify,
  createEditAction,
  createViewAction,
  formatDate,
  getForm,
  getRegister,
} from "../../utils/helpers";
import { URL_PAYMENT_TYPES } from "../../utils/urls";

const url = URL_PAYMENT_TYPES;

export const usePaymentTypes = ({ id }) => {
  const tableColumns = () => [
    { id: "name", header: "Types Name", filter: {} },
    { id: "actions", header: "Actions" },
  ];
  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        actions: (
          <FormActions
            actions={[
              createViewAction(url, item?.id),
              // createDeleteAction(
              //   `${API_PAYMENT_TYPES}${item?.id}/`,
              //   `${item?.display_text}`,
              // ),
              createEditAction(url, item?.id),
            ]}
          />
        ),
      };
    }),
  ];

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Payment Types Details",
          fields: {
            ID: item?.id,
            name: beautify(item?.name),
            generated_on: formatDate(item?.created_at),
          },
        },
      ],
    };
  };

  const formRoute = getForm(url);

  const customApi = `${API_PAYMENT_TYPES}${id}/`;

  return { tableData, tableColumns, formRoute, customApi, viewData };
};

export const usePaymentTypesForm = () => {
  const sections: any = [
    {
      title: "Payment  Types Details",
      fields: [
        {
          field_name: "name",
          label: "Types Name",
          type: "text",
          props: {
            required: true,
          },
        },
      ],
    },
  ];

  const redirect = getRegister(url);

  return { sections, redirect };
};

export function submitPaymentTypes(payload: any, id: string | number) {
  let params = { ...payload };
  return {
    id,
    api: API_PAYMENT_TYPES,
    params,
  };
}
